<style lang="less">
@import "../less/common.less";
.el-select-dropdown {
  z-index: 2007 !important;
}
#profitRateID {
  .el-dialog {
    width: 50% !important;
    min-width: 800px;
  }
  .el-dialog__header {
    text-align: left;
  }
  .el-dialog__body {
    padding: 30px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    .dialog-footer {
      padding-top: 50px;
      text-align: center;
    }
    .search-params {
      text-align: left;
      margin: 16px 0 8px 0;
    }

    .search-params.btn-search {
      display: flex;
      align-items: center;
      align-content: center;

      .el-radio-group {
        flex: 1;
      }
    }
  }
}
</style>
<template>
  <el-dialog id="profitRateID"
             class="profitRate"
             title="毛利占比"
             :visible.sync="profitRateDialog"
             width="70%"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             append-to-body>
    <div id="profitRateBody">
      <el-table class="table-common"
                :data="tableDataProfit"
                style="width: 100%"
                highlight-current-row
                border
                :row-class-name="tableRowClassName">
        <el-table-column prop="productName"
                         min-width="120"
                         label="商品名称"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover"
                        open-delay="200"
                        placement="top">
              <p>{{ scope.row.productName }}</p>
              <div slot="reference"
                   class="name-wrapper">{{ scope.row.productName }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="num"
                         label="毛利"
                         header-align="center"
                         align="right"></el-table-column>
        <el-table-column prop="type1Num"
                         label="小类毛利"
                         header-align="center"
                         align="right"></el-table-column>
        <el-table-column prop="type2Num"
                         label="中类毛利"
                         header-align="center"
                         align="right"></el-table-column>
        <el-table-column prop="allNum"
                         label="总毛利"
                         header-align="center"
                         align="right"></el-table-column>
        <el-table-column prop="type1Percent"
                         label="小类占比"
                         header-align="center"
                         align="right"></el-table-column>
        <el-table-column prop="type2Percent"
                         label="中类占比"
                         header-align="center"
                         align="right"></el-table-column>
        <el-table-column prop="allPercent"
                         label="总占比"
                         header-align="center"
                         align="right"></el-table-column>
      </el-table>
      <div class="search-params btn-search">
        <el-radio-group class="search-params"
                        v-model="searchType"
                        @change="searchInfo">
          <el-radio :label="1">中类</el-radio>
          <el-radio :label="0">小类</el-radio>
        </el-radio-group>
        <el-button size="small"
                   @click="exportExcel(null)">导出</el-button>

      </div>
      <el-table ref="tables"
                class="table-common"
                :data="tableDataProfitRate"
                style="width: 100%"
                highlight-current-row
                border
                height="300"
                show-summary
                :summary-method="getSummaries"
                :row-class-name="tableRowClassName">
        <el-table-column label-class-name="product-data-index"
                         type="index"
                         label
                         align="center"
                         fixed
                         width="50"></el-table-column>
        <el-table-column prop="productTypeName"
                         min-width="120"
                         label="类别"
                         header-align="center"
                         align="center">
          <template slot-scope="scope">
            <el-popover trigger="hover"
                        open-delay="200"
                        placement="top">
              <p>{{ scope.row.productTypeName }}</p>
              <div slot="reference"
                   class="name-wrapper">{{ scope.row.productTypeName }}</div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="money"
                         label="毛利"
                         header-align="center"
                         align="right"></el-table-column>
        <el-table-column prop="percent"
                         label="占比"
                         header-align="center"
                         align="right">
          <template slot-scope="scope">
            <div slot="reference"
                 class="name-wrapper">{{ scope.row.percent }}%</div>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="closeProfitRate(0)">关闭</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import productApi from "@/api/api-product";
import { Message } from "element-ui";
import common from "@/libs/common";
import { MessageBox } from "element-ui";
import {
  localToken
} from '@/libs/util';
let loadingProfit;
export default {
  props: {
    beginDate: {
      type: String,
      default: null
    },
    endDate: {
      type: String,
      default: null
    },
    productId: {
      type: String,
      default: null
    },
    deptId: {
      type: String,
      default: null
    },
    productName: {
      type: String,
      default: null
    },
    profitRateDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableDataProfit: [],
      searchType: 1,
      tableDataProfitRate: [],
      totalMoney: 0,
      totalPercent: 0
    }
  },

  methods: {
    getSummaries (param) {
      let that = this
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (column.property == 'percent') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          let num = common.toDecimal2(sums[index])
          sums[index] = num + '%';
          that.totalPercent = num
        } else if (column.property == 'money') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = common.toDecimal2(sums[index]);
          that.totalMoney = sums[index]
        } else {
          sums[index] = '';
        }
      });

      return sums;
    },
    //定义导出Excel表格事件
    exportExcel (val = null) {
      let that = this;
      if (that.tableDataProfitRate.length == 0) {
        const h = that.$createElement;
        MessageBox({
          message: h("div", null, [
            h("i", {
              class: "el-icon-warning message-login-title"
            }),
            h("span", { class: "message-login-txt" }, " 提示"),
            h("p", { class: "message-login-content" }, "请先查找数据！ ")
          ]),
          showCancelButton: false,
          confirmButtonText: "确定",
          beforeClose: (action, instance, done) => {
            done();
          }
        });
        return;
      }
      that.handleExportData(val)
    },

    handleExportData (val) {
      let that = this
      // 过期报废占比详情
      let tHeader = common.profitTHeader
      let filterVal = common.profitFilterVal
      var dataExport = JSON.parse(JSON.stringify(that.tableDataProfitRate));  //把要导出的数据tableData存到list
      dataExport.push({ index: '合计', productTypeName: '', money: that.totalMoney, percent: that.totalPercent })
      let title = "毛利占比详情"
      that.exportDataFun(filterVal, tHeader, dataExport, title)
    },
    // 公用导出
    exportDataFun (filterVal, tHeader, dataExport, title) {
      let that = this
      that.centerDialogVisible = true;
      var iSpeed = 1;
      that.percentage = 0;
      that.percenttxt =
        "导出数据" + dataExport.length + "条，已处理0条，正在导出,请稍等";
      var obj = setInterval(function () {
        iSpeed += 6;
        if (iSpeed >= 100) {
          // 设置达到多少进度后停止
          that.percentage = 100;
          that.percenttxt = "导出数据" + dataExport.length + "条，已完成！";
          clearInterval(obj);
          setTimeout(() => {
            that.centerDialogVisible = false;
          }, 200);
        } else {
          that.percentage = iSpeed;
          that.percenttxt =
            "导出数据" +
            dataExport.length +
            "条，已处理" +
            parseInt(dataExport.length * (iSpeed / 100)) +
            "条，正在导出，请稍等";
        }
      }, 12); // 20毫秒后函数执行一次
      require.ensure([], () => {
        const { export_json_to_excel } = require('@/Excel/Export2Excel');//注意这个Export2Excel路径
        const data = localToken.formatJson(filterVal, dataExport);
        export_json_to_excel(tHeader, data, title + common.getDateDetail());//最后一个是表名字
      })
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex % 2 === 0) {
      } else {
        return "success-row";
      }
      return "";
    },
    searchInfo () {
      let that = this
      let data = that.getData()
      loadingProfit = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector("#overdueID .el-dialog")
      });
      that.getTypeProfitPercent(data).then(res => {
        that.tableDataProfitRate = res.map((item, index) => {
          item["index"] = index + 1
          item["money"] = common.toDecimal2(item["money"])
          item["percent"] = common.toDecimal2(item["percent"])
          return item
        })
        that.$nextTick(() => {
          that.$refs['tables'].doLayout();
          loadingProfit.close();
        });
      }, err => {
        that.$nextTick(() => {
          loadingProfit.close();
        });
        console.log(err)
      })
    },
    getData () {
      let that = this
      return {
        typeFlag: that.searchType,
        beginDate: that.beginDate,
        endDate: that.endDate,
        productId: that.productId,
        deptId: that.deptId.split('&').filter(item => item)
      }
    },
    // 实时库存、销售查询时段设置
    init () {
      let that = this
      loadingProfit = that.$loading({
        lock: true,
        text: "拼命加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
        target: document.querySelector("#profitRateID .el-dialog")
      });
      let data = that.getData()
      Promise.all([that.getProfitPercent(data), that.getTypeProfitPercent(data)])
        .then(
          res => {
            res[0]['productName'] = that.productName
            res[0]['allNum'] = common.toDecimal2(res[0].allNum)
            res[0]['allPercent'] = common.toDecimal2(res[0].allPercent) + '%'
            res[0]['num'] = common.toDecimal2(res[0].num)
            res[0]['type1Num'] = common.toDecimal2(res[0].type1Num)
            res[0]['type1Percent'] = common.toDecimal2(res[0].type1Percent) + '%'
            res[0]['type2Num'] = common.toDecimal2(res[0].type2Num)
            res[0]['type2Percent'] = common.toDecimal2(res[0].type2Percent) + '%'
            that.tableDataProfit = [res[0]].map(item => item)
            that.tableDataProfitRate = res[1].map((item, index) => {
              item["index"] = index + 1
              item["money"] = common.toDecimal2(item["money"])
              item["percent"] = common.toDecimal2(item["percent"])
              return item
            })
            that.$nextTick(() => {
              that.$refs['tables'].doLayout();
              loadingProfit.close();
            });
          },
          err => {
            that.$nextTick(() => {
              loadingProfit.close();
            });
          }
        )
        .catch(err => {
          that.$nextTick(() => {
            loadingProfit.close();
          });
        });
    },
    // 单品毛利占比
    getProfitPercent (data) {
      return new Promise((resolve, reject) => {
        productApi
          .getProfitPercent(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // 分类毛利占比
    getTypeProfitPercent (data) {
      return new Promise((resolve, reject) => {
        productApi
          .getTypeProfitPercent(data)
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    closeProfitRate (value = null) {
      this.$emit("close_profitRate", value)
    }
  },
  mounted () {
  },
  watch: {
    // 路由变化
    profitRateDialog (val) {
      if (val) {
        this.init()
      } else {
        this.$nextTick(() => {
          loadingProfit.close();
        });
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/main/profitRateABC.vue